var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import VTTextField from "./VTTextField";
//---------------------------------------------------------------------------------------------------
// ## COMPONENTS ##
export default function VTHomeDialogOption(_a) {
    //-------------------------------------------------------------------------------------------------
    // ## HOOKS ##
    var value = _a.value, setValue = _a.setValue, title = _a.title, lines = _a.lines, sx = _a.sx;
    //-------------------------------------------------------------------------------------------------
    // ## USE SELECTOR ##
    //-------------------------------------------------------------------------------------------------
    // ## USE STATE ##
    //-------------------------------------------------------------------------------------------------
    // ## USE EFFECTS ##
    //-------------------------------------------------------------------------------------------------
    // ## CUSTOM FUNCTIONS ##
    // Render for the tab buttons
    //-------------------------------------------------------------------------------------------------
    // ## RETURN ##
    // OPtion on the home scenario dialog
    return (_jsx(VTTextField, { value: value, title: title, name: title, placeholder: title, multiline: lines !== 1, required: title === "Title", rows: lines, onChange: function (e) {
            if (!e.includes("https://")) {
                setValue(e);
            }
        }, sx: __assign({ width: "100%", marginBottom: "10px" }, sx) }));
}
